import tooltipDirective from '../directives/tooltip';

export default {
    install(app) {
        app.directive('tooltip', tooltipDirective);
    }
};